import { useMemo } from 'react';

import Image from 'next/image';

import { Box, BoxProps } from '@mui/material';

import { getCDNOptimizedImage } from '@arrived/common';
import { PropertyThumbnailProps } from '@arrived/components';
import { ArrivedLogoIcon } from '@arrived/images';

export const PropertySlideshowThumbnail = ({
  dataE2e,
  isForcedHeight,
  isScalableImage: _isScalableImage,
  propertyName,
  thumbnailHeight,
  thumbnailRatio,
  thumbnailSrc,
  thumbnailWidth,
  wrapperHeight,
  wrapperWidth,
  ...rest
}: PropertyThumbnailProps & BoxProps) => {
  const blurImageUrl = useMemo(() => {
    if (thumbnailSrc) {
      return getCDNOptimizedImage({
        imgUrl: thumbnailSrc,
        ratio: thumbnailRatio,
        width: thumbnailWidth,
        blur: 5,
      });
    }
  }, [thumbnailSrc, thumbnailRatio, thumbnailWidth]);

  return (
    <Box flex="1 1 auto" width={wrapperWidth || 'auto'} height={wrapperHeight || 'auto'} lineHeight={0} {...rest}>
      <Box position="relative">
        {blurImageUrl && thumbnailSrc && thumbnailHeight && thumbnailWidth ? (
          <Image
            alt={propertyName || ''}
            placeholder="blur"
            blurDataURL={blurImageUrl}
            src={thumbnailSrc}
            width={parseFloat(thumbnailWidth)}
            height={parseFloat(thumbnailHeight)}
            data-e2e={dataE2e}
            style={{
              width: '100%',
              height: isForcedHeight ? thumbnailHeight : 'auto',
              margin: 0,
              objectFit: 'cover',
            }}
          />
        ) : (
          <ArrivedLogoIcon height={thumbnailHeight} width={thumbnailWidth} />
        )}
      </Box>
    </Box>
  );
};
